module.exports = __webpack_public_path__ + "static/media/logo.da2b1b8f.svg";